import { useNavigate, useOutletContext } from "react-router";
import { NotificationType, Place } from "shared/topchef.types";
import api from "shared/topchef-api-places";

import { useContext } from "react"
import { PlaceOutletContextType } from "pages/places/home/PlacesHome";
import { NotificationContext } from "shared/NotificationContext"
import { useErrorBoundary } from "react-error-boundary";
import MyAccountFirstConnection from "./my-account-first-connection/MyAccountFirstConnection";
import MyAccountLaterConnections from "./my-account-later-connections/MyAccountLaterConnections";

const MyAccount = () => {

  const navigate = useNavigate();

  const [loggedInPlace, setLoggedInPlace] = useOutletContext<PlaceOutletContextType>();

  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const { showBoundary } = useErrorBoundary();

  
  const updateAccount = async (placeToUpdate: Place) => {


   try {
      const updatedPlace:Place = await api.updatePlace(placeToUpdate);
      setLoggedInPlace(updatedPlace);
      navigate('/places/dashboard');
    } catch (error: any) {
      const newError = new Error(`Problème pour mettre à jour vos informations : '${error.message}'`);
      triggerNotification({type: NotificationType.error, message : `${newError.message}`}); 
      return showBoundary(newError);
    }
   
  };

  if (loggedInPlace.firstConnection) {
    return (
      <MyAccountFirstConnection loggedInPlace={loggedInPlace} updateAcount={updateAccount}/>
    );
  }
  else {
    return (
      <MyAccountLaterConnections loggedInPlace={loggedInPlace} updateAcount={updateAccount}/>
    );
  }
  

}

export default MyAccount;
